import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['pay'], // 为了获取基础路由
    };
};
export const payToPathNameMap = {
    // 发票详情
    pay1010: ({ businessKey }) => commonFunc(`/invoice/upload/${businessKey}/detail`),
    // 发票签收详情
    pay1013: ({ businessKey }) => commonFunc(`/invoice/receipt/${businessKey}/detail`),
    // 费用支付申请
    pay1020: ({ businessKey }) => commonFunc(`/invoice/receipt/${businessKey}/detail`),
    // 费用支付审批
    pay1130: ({ businessKey }) => commonFunc(`/feePayment/approval/${businessKey}/detail`),
    // 工程款支付申请
    pay1030: ({ businessKey }) => commonFunc(`/constructionProgress/report/${businessKey}/detail`),
    // 工程款支付申请-作废
    pay3010: ({ businessKey, variables }) => commonFunc(`/constructionProgress/report/${variables?.refBusId}/detail`),
    // 工程款审查记录
    pay1040: ({ businessKey }) => commonFunc(`/constructionProgress/record/${businessKey}/detail`),
    // 工程款审查记录-作废
    pay3020: ({ businessKey, variables }) => commonFunc(`/constructionProgress/record/${variables?.refBusId}/detail`),
    // 工程款 支付证书
    pay1050: ({ businessKey }) => commonFunc(`/constructionProgress/certificate/${businessKey}/detail`),
    // 支付证书-作废
    pay3030: ({ businessKey, variables }) => commonFunc(`/constructionProgress/certificate/${variables?.refBusId}/detail`),
    // 竣工支付证书申请
    pay1070: ({ businessKey }) => commonFunc(`/completeSettlement/certificate/${businessKey}/detail`),
    // 竣工支付证书申请-作废
    pay3050: ({ businessKey, variables }) => commonFunc(`/completeSettlement/certificate/${variables?.refBusId}/detail`),
    // 竣工结算款申请
    pay1060: ({ businessKey }) => commonFunc(`/completeSettlement/applicate/${businessKey}/detail`),
    // 竣工结算款申请-作废
    pay3040: ({ businessKey, variables }) => {
        commonFunc(`/completeSettlement/applicate/${variables?.refBusId}/detail`);
    },
    // 最终结算申请
    pay1080: ({ businessKey }) => commonFunc(`/finalSettlement/applicate/${businessKey}/detail`),
    // 最终结算证书
    pay1090: ({ businessKey }) => commonFunc(`/finalSettlement/certificate/${businessKey}/detail`),
    // 线下转账登记
    pay1100: ({ businessKey }) => commonFunc(`/confirmPayment/offline/${businessKey}/detail`),
    // 线上款项拨付
    pay1110: ({ businessKey }) => commonFunc(`/confirmPayment/online/${businessKey}/detail`),
    // 确认收款详情
    pay1120: ({ businessKey }) => commonFunc(`/confirmPayment/receipt/${businessKey}/detail`),
    // 付款单
    pay1210: ({ businessKey }) => commonFunc(`/payment/paycheck/${businessKey}/detail`),
    // 收付款
    pay1220: ({ businessKey }) => commonFunc(`/payment/record/${businessKey}/detail`),
    // 保留金释放申请-作废
    pay3060: ({ businessKey, variables }) => commonFunc(`/finalSettlement/applicate/${variables?.refBusId}/detail`),
    // 付款单作废-作废
    pay3070: ({ businessKey, variables }) => commonFunc(`/payment/paycheck/${variables?.refBusId}/detail`),
};
